import {Address2ComponentValue} from '../component/address2-component.domain';

export type TimeInAddressValue = {
  years: number,
  months: number,
  previousAddress?: Address2ComponentValue,
} | null;
